<template>
  <b-tab title="Objeto/Identificadores" @click="() => store.currentTab = 1" :active="isTheCurrentTab" :disabled="!isTheCurrentTab && !store.isUpdate" class="mt-5">
    <b-row align-v="center">
      <b-col sm="8">
        <b-form-group label="Objeto" label-for="objeto">
          <VueSelect ref="buscarObjeto" :filterable="false" :state="validateClienteState('objeto')" v-model="form.objeto"
            :options="objetos" @open="onSearchObjetos" @search="onSearchObjetos" :clearSearchOnSelect="true" @input="setObjeto">
            <template slot="no-options"> Informe o nome do objeto </template>
            <template slot="option" slot-scope="option">
              <div class="d-flex justify-content-between">
                <div>
                  {{ option.descricao }}
                </div>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.descricao }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col>
        <button class="btn btn-primary font-weight-bold" v-b-modal.newObjectModal>
          Novo
        </button>
      </b-col>
    </b-row>
    <b-row v-if="identificadores.length > 0">
      <b-col v-for="identificador in identificadores" :key="identificador.id_identificador" sm="4">
        <b-form-group :label="identificador.descricao" :label-for="identificador.descricao">
          <b-form-input @input="(value) => changeValues(identificador.descricao, value)" maxLength="30"
            :placeholder="placeholderIdentificador(identificador)"
            :value="identificadoresFilled[identificador.descricao]" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-modal id="newObjectModal" centered title="Cadastrar novo objeto">
      <b-row>
        <b-col>
          <b-form-group id="descricao" label-for="descricao" label="Descrição">
            <b-form-input v-model="newObjetoDescricao" maxlength="50" autofocus>
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="cliente" label-for="cliente" label="Cliente">
            <VueSelect placeholder="Informe o nome do cliente" ref="buscarCliente" label="id_pessoa" :filterable="false"
              @input="setCliente" v-model="valueCliente" :options="clientes" @search="onSearchCliente">
              <template slot="no-options">
                Informe o nome do cliente
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.nome }}
                  <span class="text-muted">CNPJ/CPF:
                    {{ formatCpfCnpj(option.cnpj_cpf) }}</span>
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.nome }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-row v-if="identificadores.length > 0">
            <b-col v-for="identificador in identificadores" :key="identificador.id_identificador" sm="4">
              <b-form-group :label="identificador.descricao" :label-for="identificador.descricao">
                <b-form-input @input="(value) =>
                  newObjectChangeValues(identificador.descricao, value)" maxLength="30"
                  :placeholder="placeholderIdentificador(identificador)"
                  :value="newObjectIdentificadoresFilled[identificador.descricao]" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="() => {
          cancel();
          openModal = false;
        }"> Cancelar </b-button>
        <b-button variant="primary" ref="saveNewObject" @click="saveNewObject">
          Salvar
        </b-button>
      </template>
    </b-modal>
  </b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import PessoaMixin from "@/modules/Application/mixins/PessoaMixin";
import ObjetoData, { ObjetoDataRequired } from "../ObjetoData";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storeOS";

export default {
  name: "app-nfe-form-objetoTab",
  components: {
    VueSelect,
  },
  directives: {
    mask,
  },
  data() {
    return {
      form: {
        objeto: null,
      },
      identificadores: [],
      identificadoresFilled: {},
      newObjectIdentificadoresFilled: {},
      objetos: [],
      valueCliente: null,
      newObjetoDescricao: null,
      clientes: [],
      cliente: null,
      keyToReRender: 0,
      store,
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin, PessoaMixin],
  validations: {
    form: ObjetoDataRequired,
  },
  methods: {
    ...mapActions(["setLoading"]),
    onSearchEmail() { },
    validateClienteState(name) {
      // const { $dirty, $error } = this.$v.form[name];
      // return $dirty ? !$error : null;
    },
    placeholderIdentificador(identificador) {
      return this.isIdentificadorObrigatorio(identificador)
        ? ""
        : "Identificador não obrigatório";
    },
    isIdentificadorObrigatorio(identificador) {
      return ![false, 0, "0"].includes(identificador.obrigatorio);
    },
    isValorPreenchido(value) {
      return value !== null && value !== undefined && String(value).trim() !== "";
    },
    getValorIdentificador(identificadores, descricao) {
      if (!Array.isArray(identificadores)) return null;

      const identificador = identificadores.find(
        (item) => item.descricao === descricao
      );

      return identificador?.value ?? null;
    },
    ordenarIdentificadores(identificadores) {
      if (typeof identificadores === "string") {
        try {
          identificadores = JSON.parse(identificadores);
        } catch (e) {
          return [];
        }
      }
      if (!Array.isArray(identificadores)) return [];

      return [...identificadores].sort(
        (a, b) =>
          Number(a?.id_identificador || 0) -
          Number(b?.id_identificador || 0)
      );
    },
    getIdentificadoresFilled(identificadores) {
      const identificadoresOrdenados = this.ordenarIdentificadores(
        identificadores
      );

      return this.identificadores.reduce((acc, identificador) => ({
        ...acc,
        [identificador.descricao]: this.getValorIdentificador(
          identificadoresOrdenados,
          identificador.descricao
        ),
      }), {});
    },
    buildIdentificadoresPayload(values = {}) {
      return this.identificadores.reduce((acc, identificador) => {
        const value = values[identificador.descricao] ?? null;

        if (
          this.isIdentificadorObrigatorio(identificador) ||
          this.isValorPreenchido(value)
        ) {
          acc.push({
            id_identificador: identificador.id_identificador,
            descricao: identificador.descricao,
            value,
          });
        }

        return acc;
      }, []);
    },
    hasRequiredIdentificadorSemValor() {
      return this.identificadores.some((identificador) => (
        this.isIdentificadorObrigatorio(identificador) &&
        !this.isValorPreenchido(this.identificadoresFilled[identificador.descricao])
      ));
    },
    setObjeto(objeto) {
      this.identificadoresFilled = this.getIdentificadoresFilled(
        this.ordenarIdentificadores(objeto?.identificadores ?? [])
      );
      this.form.identificadores = this.buildIdentificadoresPayload(
        this.identificadoresFilled
      );
      this.store.formObjeto.identificadores = this.buildIdentificadoresPayload(
        this.identificadoresFilled
      );
    },
    onSearchCliente(search, loading) {
      if (search.length) {
        loading(true);
        this.searchClient(loading, search, this);
      }
    },
    searchClient: _.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getPessoaNome(search);
      loading(false);
    }, 450),
    setCliente(cliente) {
      if (this.bloquearClienteInadimplenteSelecionado(cliente)) {
        this.valueCliente = null;
        return;
      }

      this.valueCliente = cliente;
    },
    changeValues(key, value) {
      this.identificadoresFilled[key] = value
      this.store.formObjeto = {
        ...this.store.formObjeto,
        identificadores: this.buildIdentificadoresPayload(this.identificadoresFilled)
      }
    },
    newObjectChangeValues(key, value) {
      this.newObjectIdentificadoresFilled[key] = value
    },
    async saveNewObject() {
      this.addLoadingToButton('saveNewObject');
      try {
        const newObjetoData = {
          descricao: this.newObjetoDescricao,
          id_pessoa: this.valueCliente?.id_pessoa ?? null,
          identificadores: this.buildIdentificadoresPayload(
            this.newObjectIdentificadoresFilled
          ),
          status: true,
        }
        const response = await this.$http.post('/objeto/create', newObjetoData)
        const identificadoresFetched = this.ordenarIdentificadores(
          JSON.parse(response.data.data.identificadores) ?? []
        )

        this.form.objeto = {
          ...response.data.data,
          identificadores: identificadoresFetched
        };
        this.form.identificadores = identificadoresFetched;
        this.identificadoresFilled = {
          ...this.newObjectIdentificadoresFilled,
        };
        this.store.formObjeto.identificadores = this.buildIdentificadoresPayload(
          this.identificadoresFilled
        );
        this.$bvModal.hide('newObjectModal')
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton('saveNewObject');

    },
    onSearchObjetos(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchObjeto(busca.loading, busca.termo, this);
    },

    searchObjeto: _.debounce(async (loading, search, vm) => {
      vm.objetos = [];
      await vm.$nextTick();
      const data = await vm.getObjeto(search);
      vm.objetos = _.cloneDeep(data);
      loading(false);
    }, 500),

    formatEndereco(endereco) {
      if (!endereco) return "";
      const formatData = `${endereco.cep ?? ""}, ${endereco.logradouro ?? ""
        }, ${endereco.numero ?? ""}, ${endereco.bairro ?? ""} - ${endereco?.cidade?.cidade ?? ""
        } / ${endereco?.cidade?.uf ?? ""}`;
      return formatData;
    },
    async getDataInit() {
      const { data } = await this.$http.post('/identificador/get-identificador');
      this.identificadores = this.ordenarIdentificadores(data);
      if (Object.keys(this.$route.params).length !== 0) {
        const { objeto, identificadores } = this.$route.params.osData;
        this.form.objeto = objeto;
        const identificadoresParsed = this.ordenarIdentificadores(
          identificadores
        )

        this.identificadoresFilled = this.getIdentificadoresFilled(
          identificadoresParsed
        );
        this.store.formObjeto.identificadores = this.buildIdentificadoresPayload(
          this.identificadoresFilled
        );
        this.form.identificadores = this.store.formObjeto.identificadores;
      } else {
        this.identificadoresFilled = this.identificadores.reduce((acc, identificador) => ({
          ...acc,
          [identificador.descricao]: null,
        }), {})
        this.store.formObjeto.identificadores = this.buildIdentificadoresPayload(
          this.identificadoresFilled
        );
        this.form.identificadores = this.store.formObjeto.identificadores;
      }
    }
  },
  created() {
    this.form = new ObjetoData({});
    this.getDataInit();
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 1;
    },
  },
  watch: {
    form: {
      handler(newValue) {
        this.store.formObjeto = newValue;
      },
      deep: true,
    },
    'store.formObjeto': {
      handler(newValue) {
        if (newValue.fromSetClient) {
          this.form.objeto = newValue

          this.identificadoresFilled = this.getIdentificadoresFilled(
            this.ordenarIdentificadores(newValue?.identificadores ?? [])
          );

          this.form.identificadores = this.buildIdentificadoresPayload(
            this.identificadoresFilled
          );
        };
      },
      deep: true,
    },
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 2 && oldValue < newValue) {
        if (_.isEmpty(this.store.formObjeto.objeto)) {
          this.$toast.error("Objeto Obrigatório!");
          this.store.currentTab = oldValue;
          return;
        }
        if (this.hasRequiredIdentificadorSemValor()) {
          this.$toast.error("Identificador obrigatório não informado!");
          this.store.currentTab = oldValue;
          return;
        }
      }
    },
  },
};
</script>
